import { put, call, all, fork, select, takeLatest, takeEvery } from "redux-saga/effects";
import { isEmpty } from "lodash";
import moment from "moment-timezone";
import {
  presenceAttendanceProgression,
  presenceDetailsDay,
  presenceDetailsWeek,
  presenceUpdateAttendance,
  presenceUpdateMealPackage,
  presenceTripProvider,
  presenceValidateTrips,
  presenceValidateAttendances,
  presenceValidateMealPackages,
  presenceVacationsProvider
} from "./../../../lib/api/providers";
import {
  PRESENCE_GET_DETAILS_DAY,
  PRESENCE_SET_DETAILS_DAY,
  PRESENCE_UPDATE_ATTENDANCE_DETAILS_DAY,
  PRESENCE_SET_ATTENDANCE_UPDATED_DETAILS_DAY,
  PRESENCE_UPDATE_MEAL_PACKAGE_DETAILS_DAY,
  PRESENCE_SET_MEAL_PACKAGE_UPDATED_DETAILS_DAY,
  PRESENCE_SET_MEAL_PACKAGE_UPDATE_ERRORS_DETAILS_DAY,
  PRESENCE_UPDATE_TRIP_DETAILS_DAY,
  PRESENCE_SET_TRIP_UPDATED_DETAILS_DAY,
  PRESENCE_SET_TRIP_UPDATE_ERRORS_DETAILS_DAY,
  PRESENCE_SET_ATTENDANCE_UPDATE_ERRORS_DETAILS_DAY
} from "../actions/presenceDetailsDay";
import {
  PRESENCE_UPDATE_ATTENDANCE_DETAILS_WEEK,
  PRESENCE_SET_ATTENDANCE_UPDATED_DETAILS_WEEK,
  PRESENCE_SET_ATTENDANCE_UPDATE_ERRORS_DETAILS_WEEK,
  PRESENCE_UPDATE_MEAL_PACKAGE_DETAILS_WEEK,
  PRESENCE_SET_MEAL_PACKAGE_UPDATED_DETAILS_WEEK,
  PRESENCE_SET_MEAL_PACKAGE_UPDATE_ERRORS_DETAILS_WEEK,
  PRESENCE_UPDATE_TRIP_DETAILS_WEEK,
  PRESENCE_SET_TRIP_UPDATE_ERRORS_DETAILS_WEEK,
  PRESENCE_SET_TRIP_UPDATED_DETAILS_WEEK,
  PRESENCE_SET_VALIDATE_TRIPS_WEEK,
  PRESENCE_SET_VALIDATE_TRIPS_SUCCESS_WEEK,
  PRESENCE_SET_VALIDATE_TRIPS_FAILURE_WEEK,
  PRESENCE_SET_VALIDATE_ATTENDANCE_WEEK,
  PRESENCE_SET_VALIDATE_ATTENDANCE_SUCCESS_WEEK,
  PRESENCE_SET_VALIDATE_MEAL_PACKAGES_WEEK,
  PRESENCE_SET_VALIDATE_MEAL_PACKAGES_SUCCESS_WEEK,
  PRESENCE_SET_VALIDATE_MEAL_PACKAGES_FAILURE_WEEK,
  PRESENCE_SET_VALIDATE_ATTENDANCE_FAILURE_WEEK,
  PRESENCE_SET_DETAIL_WEEK_IS_LOADING,
  PRESENCE_SET_ONE_WEEK_IS_LOADING,
  PRESENCE_ERASE_DETAILS_WEEK,
  PRESENCE_ERASE_DETAILS_DAY,
  PRESENCE_UPDATE_DAY
} from "../actions/presenceDetailsWeek";
import { PRESENCE_GET_PROGRESSIONS, PRESENCE_GET_VACATIONS_LIST } from "./../actions/presence";
import { PRESENCE_GET_DETAILS_WEEK, PRESENCE_SET_DETAILS_WEEK } from "../actions/presenceDetailsWeek";

const getLogState = state => state.log;
const getState = state => state;
const getAuthState = state => state.auth || {};

const postPresenceApi = (endpoint, token, params = {}) => {
  const filters = isEmpty(params) ? { sort: { date: -1 } } : { ...params, sort: { date: -1 } };

  return endpoint
    .post(`/`, filters, {
      headers: {
        Authorization: token
      }
    })
    .then((response = {}) => {
      return response.data;
    });
};

const updatePresenceApi = (endpoint, token, params = {}) => {
  const filters = isEmpty(params) ? { sort: { date: -1 } } : { ...params, sort: { date: -1 } };

  return endpoint
    .put(`/`, filters, {
      headers: {
        Authorization: token
      }
    })
    .then((response = {}) => {
      return response.data;
    });
};

export function* getPresenceDetailsDay(action) {
  try {
    yield put({
      type: PRESENCE_SET_DETAIL_WEEK_IS_LOADING,
      payload: true
    });

    const stateAuth = yield select(getAuthState);
    yield put({
      type: PRESENCE_ERASE_DETAILS_DAY
    });
    const endDate = moment(action.payload.end_date).endOf("day");
    const currentDate = moment(action.payload.start_date).startOf("day");
    while (currentDate.isBefore(endDate)) {
      const payload = {
        user_id: action.payload.user_id,
        start_date: moment(currentDate).startOf("day"),
        end_date: moment(currentDate).endOf("day")
      };
      const values = yield call(postPresenceApi, presenceDetailsDay, stateAuth.token, payload);

      if (!isEmpty(values))
        yield put({
          type: PRESENCE_SET_DETAILS_DAY,
          payload: values[0]
        });
      currentDate.add(1, "day");
    }
  } catch (e) {
    console.log(e.message);
  }
  yield put({
    type: PRESENCE_SET_DETAIL_WEEK_IS_LOADING,
    payload: false
  });
}

export function* getPresenceDetailsWeek(action) {
  try {
    yield put({
      type: PRESENCE_SET_DETAIL_WEEK_IS_LOADING,
      payload: true
    });
    const stateAuth = yield select(getAuthState);
    yield put({
      type: PRESENCE_ERASE_DETAILS_WEEK
    });

    const endDate = moment(action.payload.end_date).endOf("week");
    const currentDate = moment(action.payload.start_date).startOf("week");

    while (currentDate.isBefore(endDate)) {
      const payload = {
        user_id: action.payload.user_id,
        start_date: moment(currentDate).startOf("week"),
        end_date: moment(currentDate).endOf("week")
      };
      const values = yield call(postPresenceApi, presenceDetailsWeek, stateAuth.token, payload);

      yield put({
        type: PRESENCE_SET_DETAILS_WEEK,
        payload: values
      });
      currentDate.add(1, "weeks");
    }
  } catch (e) {
    console.log(e.message);
  }
  yield put({
    type: PRESENCE_SET_DETAIL_WEEK_IS_LOADING,
    payload: false
  });
}

export function* getPresenceAttendanceUpdateDetailsDay(action) {
  try {
    const stateAuth = yield select(getAuthState);
    const values = yield call(updatePresenceApi, presenceUpdateAttendance, stateAuth.token, action.payload);

    yield put({
      type: PRESENCE_SET_ATTENDANCE_UPDATED_DETAILS_DAY,
      payload: values,
      index: action.payload.index
    });
  } catch (e) {
    console.log(e.response);
    yield put({
      type: PRESENCE_SET_ATTENDANCE_UPDATE_ERRORS_DETAILS_DAY,
      payload: e.response.data && e.response.data.data
    });
  }
}

export function* getPresenceAttendanceUpdateDetailsWeek(action) {
  try {
    const stateAuth = yield select(getAuthState);
    const values = yield call(updatePresenceApi, presenceUpdateAttendance, stateAuth.token, action.payload);

    yield put({
      type: PRESENCE_SET_ATTENDANCE_UPDATED_DETAILS_WEEK,
      payload: values,
      weekIndex: action.payload.index,
      dayIndex: action.payload.dayIndex
    });
  } catch (e) {
    console.log(e.response);
    yield put({
      type: PRESENCE_SET_ATTENDANCE_UPDATE_ERRORS_DETAILS_WEEK,
      payload: e.response.data && e.response.data.data
    });
  }
}

export function* getPresenceTripUpdateDetailsDay(action) {
  try {
    const stateAuth = yield select(getAuthState);
    const values = yield call(updatePresenceApi, presenceTripProvider, stateAuth.token, action.payload);

    yield put({
      type: PRESENCE_SET_TRIP_UPDATED_DETAILS_DAY,
      payload: values,
      index: action.payload.index
    });
  } catch (e) {
    console.log(e.response);
    yield put({ type: PRESENCE_SET_TRIP_UPDATE_ERRORS_DETAILS_DAY, payload: e.response.data && e.response.data.error });
  }
}

export function* getPresenceMealPackageUpdateDetailsDay(action) {
  try {
    const stateAuth = yield select(getAuthState);
    const values = yield call(updatePresenceApi, presenceUpdateMealPackage, stateAuth.token, action.payload);

    yield put({
      type: PRESENCE_SET_MEAL_PACKAGE_UPDATED_DETAILS_DAY,
      payload: values,
      index: action.payload.index
    });
  } catch (e) {
    console.log(e.response);
    yield put({
      type: PRESENCE_SET_MEAL_PACKAGE_UPDATE_ERRORS_DETAILS_DAY,
      payload: e.response.data && e.response.data.data
    });
  }
}

export function* getPresenceMealPackageUpdateDetailsWeek(action) {
  try {
    const stateAuth = yield select(getAuthState);
    const values = yield call(updatePresenceApi, presenceUpdateMealPackage, stateAuth.token, action.payload);

    yield put({
      type: PRESENCE_SET_MEAL_PACKAGE_UPDATED_DETAILS_WEEK,
      payload: values,
      weekIndex: action.payload.index,
      dayIndex: action.payload.dayIndex
    });

    if (action.payload.validated) {
      yield getPresenceDetailsWeek(action);
    }
  } catch (e) {
    console.log(e.response);
    yield put({
      type: PRESENCE_SET_MEAL_PACKAGE_UPDATE_ERRORS_DETAILS_WEEK,
      payload: e.response.data && e.response.data.data
    });
  }
}

export function* getPresenceTripDetailsWeek(action) {
  try {
    const stateAuth = yield select(getAuthState);
    const values = yield call(updatePresenceApi, presenceTripProvider, stateAuth.token, action.payload);

    yield put({
      type: PRESENCE_SET_TRIP_UPDATED_DETAILS_WEEK,
      payload: values,
      weekIndex: action.payload.weekIndex,
      dayIndex: action.payload.dayIndex,
      tripIndex: action.payload.tripIndex
    });
  } catch (e) {
    console.log(e.response);
    yield put({
      type: PRESENCE_SET_TRIP_UPDATE_ERRORS_DETAILS_WEEK,
      payload: e.response.data && e.response.data.error
    });
  }
}

export function* getPresenceValidateTripsWeek(action) {
  try {
    const stateAuth = yield select(getAuthState);
    yield call(postPresenceApi, presenceValidateTrips, stateAuth.token, action.payload);

    yield put({
      type: PRESENCE_SET_VALIDATE_TRIPS_SUCCESS_WEEK,
      payload: {
        text: "Semaine validée",
        indexWeek: action.payload.indexWeek
      }
    });
  } catch (e) {
    let errorMsg = "La semaine n'a pas pu être validée";
    if (e.response && e.response.data) {
      errorMsg = errorMsg + " : " + e.response.data.error;
    }
    yield put({
      type: PRESENCE_SET_VALIDATE_TRIPS_FAILURE_WEEK,
      payload: errorMsg
    });
  }
}

export function* getPresenceValidateAttendancesWeek(action) {
  try {
    yield put({
      type: PRESENCE_SET_DETAIL_WEEK_IS_LOADING,
      payload: true
    });
    const stateAuth = yield select(getAuthState);
    const state = yield select(getState);
    const statePresenceWeek = state.presenceDetailsWeek || {};
    yield put({
      type: PRESENCE_SET_ONE_WEEK_IS_LOADING,
      payload: { weekIsLoading: true, indexWeek: action.payload.indexWeek }
    });

    yield call(postPresenceApi, presenceValidateAttendances, stateAuth.token, action.payload);

    yield put({
      type: PRESENCE_SET_VALIDATE_ATTENDANCE_SUCCESS_WEEK,
      payload: {
        text: "Semaine validée"
      }
    });

    const payload = {
      user_id: statePresenceWeek.get("userId"),
      start_date: moment(action.payload.currentDate).startOf("week"),
      end_date: moment(action.payload.currentDate).endOf("week")
    };
    const values = yield call(postPresenceApi, presenceDetailsWeek, stateAuth.token, payload);
    yield put({
      type: PRESENCE_SET_DETAILS_WEEK,
      payload: values
    });
  } catch (e) {
    console.log(e);
    console.log(e.response);
    yield put({
      type: PRESENCE_SET_VALIDATE_ATTENDANCE_FAILURE_WEEK,
      payload: "La semaine n'a pas pu être validée"
    });
  }
  yield put({
    type: PRESENCE_SET_ONE_WEEK_IS_LOADING,
    payload: { weekIsLoading: false }
  });
  yield put({
    type: PRESENCE_SET_DETAIL_WEEK_IS_LOADING,
    payload: false
  });
}

export function* getPresenceValidateMealPackagesWeek(action) {
  try {
    yield put({
      type: PRESENCE_SET_DETAIL_WEEK_IS_LOADING,
      payload: true
    });
    yield put({
      type: PRESENCE_SET_ONE_WEEK_IS_LOADING,
      payload: { weekIsLoading: true, indexWeek: action.payload.indexWeek }
    });

    const stateAuth = yield select(getAuthState);
    const state = yield select(getState);
    const statePresenceWeek = state.presenceDetailsWeek || {};

    yield call(postPresenceApi, presenceValidateMealPackages, stateAuth.token, action.payload);
    const payload = {
      user_id: statePresenceWeek.get("userId"),
      start_date: moment(action.payload.currentDate).startOf("week"),
      end_date: moment(action.payload.currentDate).endOf("week")
    };
    const values = yield call(postPresenceApi, presenceDetailsWeek, stateAuth.token, payload);

    yield put({
      type: PRESENCE_SET_DETAILS_WEEK,
      payload: values
    });
  } catch (e) {
    console.log(e.response);
    yield put({
      type: PRESENCE_SET_VALIDATE_MEAL_PACKAGES_FAILURE_WEEK,
      payload: "La semaine n'a pas pu être validée"
    });
  }
  yield put({
    type: PRESENCE_SET_ONE_WEEK_IS_LOADING,
    payload: { weekIsLoading: false }
  });
  yield put({
    type: PRESENCE_SET_DETAIL_WEEK_IS_LOADING,
    payload: false
  });
}

export function* getPresenceDay(action) {
  try {
    const stateAuth = yield select(getAuthState);
    const state = yield select(getState);
    const statePresenceDay = state.presenceDetailsDay || {};

    const endDate = moment(action.payload.end_date).endOf("day");
    const currentDate = moment(action.payload.start_date).startOf("day");
    while (currentDate.isBefore(endDate)) {
      const payload = {
        user_id: statePresenceDay.get("userId"),
        start_date: moment(currentDate).startOf("day"),
        end_date: moment(currentDate).endOf("day")
      };
      const values = yield call(postPresenceApi, presenceDetailsDay, stateAuth.token, payload);

      if (!isEmpty(values))
        yield put({
          type: PRESENCE_SET_DETAILS_DAY,
          payload: values[0]
        });
      currentDate.add(1, "day");
    }
  } catch (e) {
    console.log(e.response);
  }
}

export default function* root() {
  yield all([
    takeEvery(PRESENCE_GET_DETAILS_DAY, getPresenceDetailsDay),
    takeLatest(PRESENCE_GET_DETAILS_WEEK, getPresenceDetailsWeek),
    takeLatest(PRESENCE_UPDATE_ATTENDANCE_DETAILS_DAY, getPresenceAttendanceUpdateDetailsDay),
    takeLatest(PRESENCE_UPDATE_MEAL_PACKAGE_DETAILS_DAY, getPresenceMealPackageUpdateDetailsDay),
    takeLatest(PRESENCE_UPDATE_TRIP_DETAILS_DAY, getPresenceTripUpdateDetailsDay),
    takeEvery(PRESENCE_UPDATE_ATTENDANCE_DETAILS_WEEK, getPresenceAttendanceUpdateDetailsWeek),
    takeLatest(PRESENCE_UPDATE_MEAL_PACKAGE_DETAILS_WEEK, getPresenceMealPackageUpdateDetailsWeek),
    takeEvery(PRESENCE_UPDATE_TRIP_DETAILS_WEEK, getPresenceTripDetailsWeek),
    takeLatest(PRESENCE_SET_VALIDATE_TRIPS_WEEK, getPresenceValidateTripsWeek),
    takeLatest(PRESENCE_SET_VALIDATE_ATTENDANCE_WEEK, getPresenceValidateAttendancesWeek),
    takeLatest(PRESENCE_SET_VALIDATE_MEAL_PACKAGES_WEEK, getPresenceValidateMealPackagesWeek),
    takeLatest(PRESENCE_UPDATE_DAY, getPresenceDay)
  ]);
}



// WEBPACK FOOTER //
// src/modules/presence/sagas/presenceSagas.js